export var SECTION_ACTIONS;
(function (SECTION_ACTIONS) {
    SECTION_ACTIONS["CHANGE_SECTION_TAB"] = "CHANGE_SECTION_TAB";
    SECTION_ACTIONS["CONTINUE_TO_NEXT_SECTION_TAB"] = "CONTINUE_TO_NEXT_SECTION_TAB";
})(SECTION_ACTIONS || (SECTION_ACTIONS = {}));
export function changeSection(sectionIndex) {
    return {
        type: SECTION_ACTIONS.CHANGE_SECTION_TAB,
        sectionIndex
    };
}
export function continueToNextSection() {
    return {
        type: SECTION_ACTIONS.CONTINUE_TO_NEXT_SECTION_TAB
    };
}
